<template functional>
  <v-tooltip :disabled="!props.suspensionReason" bottom>
    <template #activator="{on, attrs}">
      <component
        :is="$options.appChip()"
        color="edit"
        :class-list="classList"
        text-color="white--text"
        v-bind="attrs"
        v-on="on"
      >
        {{ parent.$t("common:badge.suspended.label", "Suspended") }}
      </component>
    </template>
    <span>{{ props.suspensionReason }}</span>
  </v-tooltip>
</template>
<script>
import AppChip from "@elements/AppChip.vue";
export default {
  name: "AppShowSuspension",
  props: {
    suspensionReason: {
      type: String,
      default: null
    },
    classList: {
      type: String,
      default: null
    }
  },
  appChip() {
    return AppChip;
  },
  fragments: {
    suspension: `
      suspended
      suspensionReason
    `
  }
};
</script>
